import { createContext } from 'react';

import type { AppDefinition } from './contracts';

export const AppContext = createContext<AppDefinition | null>(null);
